import React from 'react';
import { PageBanner } from '../components/PageBanner';
import { ServicesSection } from '../components/ServicesSection';
import { ContactCTA } from '../components/ContactCTA';
export function ServicesPage() {
  return <main data-id="element-1260">
      <PageBanner title="Our Services" subtitle="Comprehensive home healthcare solutions tailored to your unique needs." breadcrumbs={[{
      label: 'Services',
      path: '/services'
    }]} data-id="element-1261" />
      <ServicesSection data-id="element-1262" />
      <ContactCTA data-id="element-1263" />
    </main>;
}